import { useCart as useCartOriginal } from '@pnc/gopay-cart-setup-util/lib/react';
import { addCurrentBookingToCart } from '../actions/BookingForm';
import renderModes from '../constants/renderModes';
import { useManiless } from '../components/ManilessProvider';
import ConfigStore from '../stores/Config';

const createCartObject = ({ cart, currentPageRoute, onAddToCart }) => {
  return {
    addCurrentService: () => {
      const fn = addCurrentBookingToCart({
        cart,
        currentPageRoute
      });

      if (onAddToCart) {
        onAddToCart();
      }

      return fn;
    }
  };
};

const stubCart = {
  addItem: item => console.log('GoPay cart.addItem()', item)
};

const useCart = ({ onAddToCart }) => {
  if (!ConfigStore.isGopayCartOn()) {
    return { cart: null };
  }

  const { currentPageRoute, renderMode } = useManiless();

  // BEAR-1458: Due to an iOS safari bug, we do *not* want to invoke useCartOriginal() in editor
  if (renderMode !== renderModes.PUBLISH) {
    return { cart: createCartObject({ cart: stubCart, currentPageRoute, onAddToCart }) };
  }

  const { cart: originalCart } = useCartOriginal();

  if (!originalCart) {
    return { cart: null };
  }

  const cart = createCartObject({ cart: originalCart, currentPageRoute, onAddToCart });

  return { cart };
};

export default useCart;
